import styled from 'styled-components';

export const StyledAppUsage = styled.div`
  .feature {
    .Polaris-Badge {
      background-color: transparent;
      svg {
        fill: #303030;
      }
      .Polaris-Text--root {
        font-size: 0.8125rem;
        color: var(--p-color-text-secondary);
      }
    }
  }

  .usage-icon {
    width: 1.65rem;
    height: 1.65rem;
    background-color: #eef2ff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.25rem;
    padding-inline: 0.1rem;
    &.yellow {
      background-color: #fffbeb;
      padding-inline: 0.1rem;
      padding-block: 0 0.1rem;
    }
  }

  .skeleton {
    height: 8.0625rem;
  }
  .Polaris-Grid-Cell > div,
  .Polaris-Grid-Cell > div > div {
    height: 100%;
  }

  .usage-rows {
    display: grid;
    grid-template-rows: repeat(5, 1.75rem);
    row-gap: 0.25rem;
  }
  .usage-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    min-width: 0;
  }
  .usage-row-inline {
    justify-content: flex-start;
    gap: 0.75rem;
  }
  .usage-progress {
    width: 100%;
  }
  .usage-used-total {
    flex-shrink: 0;
  }
  .usage-progress-inline {
    flex: 1;
  }
  .usage-row.with-divider {
    border-top: 1px solid var(--p-color-border-secondary);
  }
`;
